import { useEffect, useState } from 'react';

const isBrowser =
	typeof window !== 'undefined' && typeof window.document !== 'undefined';

const getInitialState = (query, defaultState) => {
	// Prevent a React hydration mismatch when a default value is provided by not defaulting to window.matchMedia(query).matches.
	if (defaultState !== undefined) {
		return defaultState;
	}

	if (isBrowser) {
		return window?.matchMedia(query).matches;
	}

	return false;
};

const noopMql = (defaultState) => ({
	matches: defaultState || !window?.DDC?.client?.isMobile,
	addEventListener: () => {},
	removeEventListener: () => {}
});

const useMedia = (query, defaultState = false) => {
	const [state, setState] = useState(getInitialState(query, defaultState));

	useEffect(() => {
		let mounted = true;
		const mql =
			typeof window?.matchMedia === 'function'
				? window.matchMedia(query)
				: noopMql(defaultState);
		const onChange = () => {
			if (!mounted) {
				return;
			}
			setState(!!mql.matches);
		};

		mql?.addEventListener('change', onChange);
		setState(mql.matches);

		return () => {
			mounted = false;
			mql?.removeEventListener('change', onChange);
		};
	}, [defaultState, query]);

	return state;
};

export default useMedia;
